var _path, _path2, _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoServiceCreate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.108 56.282l17.068-9.854.002-.002.003.002.003.002v19.714l-.003.002a.027.027 0 01-.003.001l-.002-.001-17.068-9.854-.003-.002v-.003-.004l.003-.001z",
    fill: "#F6F8FF",
    stroke: "#506BCA",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.072 41.136H62.86c6.22 0 11.26 5.041 11.26 11.26v17.292a1.75 1.75 0 01-1.75 1.75H32.072a1.75 1.75 0 01-1.75-1.75V42.886c0-.966.783-1.75 1.75-1.75z",
    fill: "#F6F8FF",
    stroke: "#506BCA",
    strokeWidth: 2.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.471,
    y: 28.563,
    width: 43.799,
    height: 30.301,
    rx: 4.75,
    fill: "#fff",
    stroke: "#506BCA",
    strokeWidth: 2.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#VideoServiceCreate_svg__clip0_931_11964)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "VideoServiceCreate_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.618 34.051a2 2 0 00-3.157 0l-13.028 16.75-7.198-8.547a2 2 0 00-3.06 0l-13.247 15.73c-1.096 1.3-.17 3.288 1.53 3.288H68.7c1.665 0 2.6-1.914 1.579-3.228L51.618 34.051z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.618 34.051a2 2 0 00-3.157 0l-13.028 16.75-7.198-8.547a2 2 0 00-3.06 0l-13.247 15.73c-1.096 1.3-.17 3.288 1.53 3.288H68.7c1.665 0 2.6-1.914 1.579-3.228L51.618 34.051z",
    fill: "#F6F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.46 34.051l-1.815-1.412 1.816 1.412zm3.158 0l1.816-1.412-1.816 1.412zm-16.185 16.75l-1.76 1.481 1.831 2.174 1.745-2.243-1.816-1.412zm-7.198-8.547l-1.76 1.482 1.76-1.482zm-3.06 0l-1.759-1.482 1.76 1.482zm-13.247 15.73l1.76 1.481-1.76-1.481zm19.444 3.288l.007-2.3h-.007v2.3zm38.908-3.228l1.815-1.412-1.815 1.412zm-20.004-22.58a.3.3 0 01-.473 0l3.63-2.825c-1.72-2.213-5.066-2.213-6.788 0l3.631 2.824zM37.248 52.212l13.028-16.75-3.63-2.824-13.029 16.75 3.632 2.824zm-10.772-8.477l7.198 8.547 3.518-2.964-7.198-8.547-3.518 2.964zm.459 0a.3.3 0 01-.46 0l3.52-2.964a4.3 4.3 0 00-6.579 0l3.519 2.964zm-13.248 15.73l13.248-15.73-3.519-2.964-13.247 15.73 3.518 2.963zm-.23-.494a.33.33 0 01.273.173.33.33 0 01-.043.32l-3.518-2.963c-2.356 2.797-.368 7.07 3.289 7.07v-4.6zm17.915 0H13.458v4.6h17.914v-4.6zm.006 0h.001l-.014 4.6h.013v-4.6zm37.323 0H31.378v4.6h37.323v-4.6zm-.237.484a.329.329 0 01-.032-.316.328.328 0 01.27-.168v4.6c3.577 0 5.59-4.116 3.393-6.94l-3.63 2.824zM49.803 35.463l18.661 23.993 3.631-2.824-18.661-23.993-3.631 2.824z",
    fill: "#506BCA",
    mask: "url(#VideoServiceCreate_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.165 51.477v14.562h-8.25V51.477a4.125 4.125 0 118.25 0z",
    stroke: "#506BCA",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.182,
    cy: 37.02,
    r: 3.105,
    stroke: "#506BCA",
    strokeWidth: 2.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.471,
    y: 28.563,
    width: 43.799,
    height: 30.301,
    rx: 4.75,
    stroke: "#506BCA",
    strokeWidth: 2.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "VideoServiceCreate_svg__clip0_931_11964"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(17.827 28.5)",
    d: "M0 0h43v30H0z"
  })))));
}
export default __webpack_public_path__ + "media/service/VideoServiceCreate-8cb4790d.svg";
export { SvgVideoServiceCreate as ReactComponent };